import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import pl from './pl.json'

i18n.use(initReactI18next).init({
  resources: {
    pl: { translation: pl },
  },
  lng: 'pl',
  fallbackLng: 'pl',
  interpolation: {
    escapeValue: false,
  },
})

/**
 * Lazy-loaders for non-default languages.
 *
 * `en` is the only other language the main site UI exposes via the header
 * switcher. The remaining languages (`fr`, `es`, `de`, `ru`) only contain
 * keys the embed widget needs — they're activated solely through
 * `/embed?lang=...` and fall back to the default (`pl`) for any key not
 * defined in their JSON. This keeps the bundles small without translating
 * the entire site.
 */
const LAZY_LOADERS: Record<string, () => Promise<{ default: object }>> = {
  en: () => import('./en.json'),
  fr: () => import('./fr.json'),
  es: () => import('./es.json'),
  de: () => import('./de.json'),
  ru: () => import('./ru.json'),
  uk: () => import('./uk.json'),
}

export async function loadLanguage(lang: string): Promise<void> {
  if (lang === 'pl') return
  if (i18n.hasResourceBundle(lang, 'translation')) return
  const loader = LAZY_LOADERS[lang]
  if (!loader) return
  const mod = await loader()
  i18n.addResourceBundle(lang, 'translation', mod.default)
}

/** Backward-compatible alias used by the main-site header EN switcher. */
export const loadEnglish = () => loadLanguage('en')

export default i18n
